import React from "react";
import Products from "../../components/products/Products";
import Hero from "../../components/hero/Hero";


const HomePage = ({activeCode}) => {
  

  return (
    <>
      <Hero />

      <Products campaignCode={activeCode} />

    </>
  );
};

export default HomePage;
